module.exports = __webpack_public_path__ + "static/img/tips.04b90ab4.svg";